import { render, staticRenderFns } from "./ModalCompletaNotificado.vue?vue&type=template&id=78311be3"
import script from "./ModalCompletaNotificado.vue?vue&type=script&lang=js"
export * from "./ModalCompletaNotificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78311be3')) {
      api.createRecord('78311be3', component.options)
    } else {
      api.reload('78311be3', component.options)
    }
    module.hot.accept("./ModalCompletaNotificado.vue?vue&type=template&id=78311be3", function () {
      api.rerender('78311be3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/completaInfo/modales/ModalCompletaNotificado.vue"
export default component.exports